import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1cd6776f = () => interopDefault(import('..\\pages\\enroll-complete.vue' /* webpackChunkName: "pages/enroll-complete" */))
const _5221f7b7 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _0e6f06b6 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages/errors/index" */))
const _ddaa2784 = () => interopDefault(import('..\\pages\\hcp\\index.vue' /* webpackChunkName: "pages/hcp/index" */))
const _b1fcfa9c = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages/not-eligible" */))
const _f2c46ce4 = () => interopDefault(import('..\\pages\\patient\\index.vue' /* webpackChunkName: "pages/patient/index" */))
const _1d5b1a2a = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _5ffd7ba5 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages/unlock" */))
const _f68bf83c = () => interopDefault(import('..\\pages\\upload.vue' /* webpackChunkName: "pages/upload" */))
const _71ea24d6 = () => interopDefault(import('..\\pages\\upload-document.vue' /* webpackChunkName: "pages/upload-document" */))
const _05bb2b7a = () => interopDefault(import('..\\pages\\upload-documents-success.vue' /* webpackChunkName: "pages/upload-documents-success" */))
const _41c6a71c = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages/errors/404" */))
const _4e9ca2b3 = () => interopDefault(import('..\\pages\\hcp\\assistance-program.vue' /* webpackChunkName: "pages/hcp/assistance-program" */))
const _668c86b6 = () => interopDefault(import('..\\pages\\hcp\\clinical-information.vue' /* webpackChunkName: "pages/hcp/clinical-information" */))
const _477e0688 = () => interopDefault(import('..\\pages\\hcp\\diagnosis-information.vue' /* webpackChunkName: "pages/hcp/diagnosis-information" */))
const _1ffaf4be = () => interopDefault(import('..\\pages\\hcp\\docusign.vue' /* webpackChunkName: "pages/hcp/docusign" */))
const _7c40a279 = () => interopDefault(import('..\\pages\\hcp\\eligibility.vue' /* webpackChunkName: "pages/hcp/eligibility" */))
const _7bd4881a = () => interopDefault(import('..\\pages\\hcp\\eye-care-support.vue' /* webpackChunkName: "pages/hcp/eye-care-support" */))
const _6dd21f68 = () => interopDefault(import('..\\pages\\hcp\\health-insurance-information.vue' /* webpackChunkName: "pages/hcp/health-insurance-information" */))
const _6e8806a5 = () => interopDefault(import('..\\pages\\hcp\\insurance-information.vue' /* webpackChunkName: "pages/hcp/insurance-information" */))
const _e8300c60 = () => interopDefault(import('..\\pages\\hcp\\patient-information.vue' /* webpackChunkName: "pages/hcp/patient-information" */))
const _a5f1f754 = () => interopDefault(import('..\\pages\\hcp\\pharmacy-information.vue' /* webpackChunkName: "pages/hcp/pharmacy-information" */))
const _50a5143a = () => interopDefault(import('..\\pages\\hcp\\prescriber-site-information.vue' /* webpackChunkName: "pages/hcp/prescriber-site-information" */))
const _d52e4422 = () => interopDefault(import('..\\pages\\hcp\\success.vue' /* webpackChunkName: "pages/hcp/success" */))
const _4ec7e763 = () => interopDefault(import('..\\pages\\patient\\assistance-program.vue' /* webpackChunkName: "pages/patient/assistance-program" */))
const _41e3556e = () => interopDefault(import('..\\pages\\patient\\docusign.vue' /* webpackChunkName: "pages/patient/docusign" */))
const _5d4c43c9 = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages/patient/eligibility" */))
const _19b643f5 = () => interopDefault(import('..\\pages\\patient\\insurance-information.vue' /* webpackChunkName: "pages/patient/insurance-information" */))
const _72f13e26 = () => interopDefault(import('..\\pages\\patient\\patient-authorization.vue' /* webpackChunkName: "pages/patient/patient-authorization" */))
const _232bd423 = () => interopDefault(import('..\\pages\\patient\\patient-authorization-success.vue' /* webpackChunkName: "pages/patient/patient-authorization-success" */))
const _ddb569c0 = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages/patient/patient-information" */))
const _076d5d50 = () => interopDefault(import('..\\pages\\patient\\patient-support-services.vue' /* webpackChunkName: "pages/patient/patient-support-services" */))
const _68e30010 = () => interopDefault(import('..\\pages\\patient\\prescriber-information.vue' /* webpackChunkName: "pages/patient/prescriber-information" */))
const _0cccb182 = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages/patient/success" */))
const _4bd60ce9 = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages/pharmacy/eligibility" */))
const _554b5a83 = () => interopDefault(import('..\\pages\\pharmacy\\ncpdp.vue' /* webpackChunkName: "pages/pharmacy/ncpdp" */))
const _2a63f440 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages/pharmacy/patient-information" */))
const _0e5bd981 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '#{BasePath}#/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/enroll-complete",
    component: _1cd6776f,
    name: "enroll-complete"
  }, {
    path: "/error",
    component: _5221f7b7,
    name: "error"
  }, {
    path: "/errors",
    component: _0e6f06b6,
    name: "errors"
  }, {
    path: "/hcp",
    component: _ddaa2784,
    name: "hcp"
  }, {
    path: "/not-eligible",
    component: _b1fcfa9c,
    name: "not-eligible"
  }, {
    path: "/patient",
    component: _f2c46ce4,
    name: "patient"
  }, {
    path: "/thank-you",
    component: _1d5b1a2a,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _5ffd7ba5,
    name: "unlock"
  }, {
    path: "/upload",
    component: _f68bf83c,
    name: "upload"
  }, {
    path: "/upload-document",
    component: _71ea24d6,
    name: "upload-document"
  }, {
    path: "/upload-documents-success",
    component: _05bb2b7a,
    name: "upload-documents-success"
  }, {
    path: "/errors/404",
    component: _41c6a71c,
    name: "errors-404"
  }, {
    path: "/hcp/assistance-program",
    component: _4e9ca2b3,
    name: "hcp-assistance-program"
  }, {
    path: "/hcp/clinical-information",
    component: _668c86b6,
    name: "hcp-clinical-information"
  }, {
    path: "/hcp/diagnosis-information",
    component: _477e0688,
    name: "hcp-diagnosis-information"
  }, {
    path: "/hcp/docusign",
    component: _1ffaf4be,
    name: "hcp-docusign"
  }, {
    path: "/hcp/eligibility",
    component: _7c40a279,
    name: "hcp-eligibility"
  }, {
    path: "/hcp/eye-care-support",
    component: _7bd4881a,
    name: "hcp-eye-care-support"
  }, {
    path: "/hcp/health-insurance-information",
    component: _6dd21f68,
    name: "hcp-health-insurance-information"
  }, {
    path: "/hcp/insurance-information",
    component: _6e8806a5,
    name: "hcp-insurance-information"
  }, {
    path: "/hcp/patient-information",
    component: _e8300c60,
    name: "hcp-patient-information"
  }, {
    path: "/hcp/pharmacy-information",
    component: _a5f1f754,
    name: "hcp-pharmacy-information"
  }, {
    path: "/hcp/prescriber-site-information",
    component: _50a5143a,
    name: "hcp-prescriber-site-information"
  }, {
    path: "/hcp/success",
    component: _d52e4422,
    name: "hcp-success"
  }, {
    path: "/patient/assistance-program",
    component: _4ec7e763,
    name: "patient-assistance-program"
  }, {
    path: "/patient/docusign",
    component: _41e3556e,
    name: "patient-docusign"
  }, {
    path: "/patient/eligibility",
    component: _5d4c43c9,
    name: "patient-eligibility"
  }, {
    path: "/patient/insurance-information",
    component: _19b643f5,
    name: "patient-insurance-information"
  }, {
    path: "/patient/patient-authorization",
    component: _72f13e26,
    name: "patient-patient-authorization"
  }, {
    path: "/patient/patient-authorization-success",
    component: _232bd423,
    name: "patient-patient-authorization-success"
  }, {
    path: "/patient/patient-information",
    component: _ddb569c0,
    name: "patient-patient-information"
  }, {
    path: "/patient/patient-support-services",
    component: _076d5d50,
    name: "patient-patient-support-services"
  }, {
    path: "/patient/prescriber-information",
    component: _68e30010,
    name: "patient-prescriber-information"
  }, {
    path: "/patient/success",
    component: _0cccb182,
    name: "patient-success"
  }, {
    path: "/pharmacy/eligibility",
    component: _4bd60ce9,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/ncpdp",
    component: _554b5a83,
    name: "pharmacy-ncpdp"
  }, {
    path: "/pharmacy/patient-information",
    component: _2a63f440,
    name: "pharmacy-patient-information"
  }, {
    path: "/",
    component: _0e5bd981,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
